import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useParams } from 'react-router';
import DetailsBanner from '../DetailsBanner/DetailsBanner';
import DetailsBody from '../DetailsBody/DetailsBody';
import './Details.css';

const Details = () => {
    let { idLeague } = useParams();
    const [league, setLeague] = useState([]);
    useEffect(() => {
        const url = `https://www.thesportsdb.com/api/v1/json/2/lookupleague.php?id=${idLeague}`;
        fetch(url)
            .then((response) => response.json())
            .then(data => {
                setLeague(data.leagues[0]);
                // const sportsTypes = data.leagues[0];
                // console.log(sportsTypes);
                // sportsTypes.filter(sportsTypes => )
                // console.log(data.leagues[0]);
        })
    },[])



    return (
        <div className="details-container">
            <DetailsBanner league={league}></DetailsBanner>
            <Container>
                <div className="details-container">
                    <DetailsBody league={league}></DetailsBody>
                </div>
            </Container>
        </div>
    );
};

export default Details;